import { render, staticRenderFns } from "./GuestAuthModal.vue?vue&type=template&id=2fab1880&scoped=true"
import script from "./GuestAuthModal.vue?vue&type=script&lang=js"
export * from "./GuestAuthModal.vue?vue&type=script&lang=js"
import style0 from "./GuestAuthModal.vue?vue&type=style&index=0&id=2fab1880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab1880",
  null
  
)

export default component.exports